import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Divider, Flex, Form, Image, Input, Row, Select, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef } from "react";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { FechamentoFinanceiroDTOModel } from "../../../../models/fechamentoFinanceiro/fechamentoFinanceiroDTOModel";
import { setModalCadastrarFechamentoFinanceiro } from "../../../../redux/slices/fechamentoFinanceiro/fechamentoFinanceiroSlice";
import { atualizarFechamentoFinanceiro } from "../../../../services/fechamentoFinanceiroService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";

const FecharEmpresaFechamentoFinanceiro = () => {
  //estados globais
  const fechamentoFinanceiroState = useAppSelector((state) => state.fechamentoFinanceiro);
  const empresaState = useAppSelector((state) => state.empresa);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<FechamentoFinanceiroDTOModel>();

  const editar = Object.values(fechamentoFinanceiroState.entity).length !== 0;

  const dataFechamentoMovimentacao = Form.useWatch("dataFechamentoMovimentacao", form);

  const verificaInputMovimentacao = dataFechamentoMovimentacao === null || dataFechamentoMovimentacao === undefined;

  const inputInicial = useRef<any>(null);

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      form.setFieldsValue({
        ...fechamentoFinanceiroState.entity,
        dataFechamentoClassificacao: fechamentoFinanceiroState.entity.dataFechamentoClassificacao && dayjs(fechamentoFinanceiroState.entity.dataFechamentoClassificacao),
        dataFechamentoMovimentacao: fechamentoFinanceiroState.entity.dataFechamentoMovimentacao && dayjs(fechamentoFinanceiroState.entity.dataFechamentoMovimentacao),
      });
    }
  }, [fechamentoFinanceiroState.entity]);

  const onValuesForm = (changedValues: any, allValues: any) => {
    if (allValues.dataFechamentoMovimentacao === null) {
      form.setFieldValue("dataFechamentoClassificacao", null);
    }
  };

  const submit = (values: any) => {
    values["idUsuarioAlteracao"] = Number(persistedState.user.id);
    values["dataHoraAlteracao"] = new Date().toISOString();
    dispatch(
      atualizarFechamentoFinanceiro(
        editar
          ? { value: { ...fechamentoFinanceiroState.entity, ...values, idEmpresa: null }, busca: fechamentoFinanceiroState.busca }
          : { value: { ...fechamentoFinanceiroState.entity, ...values }, busca: fechamentoFinanceiroState.busca }
      )
    );
  };

  const voltar = () => {
    dispatch(setModalCadastrarFechamentoFinanceiro(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit} onValuesChange={onValuesForm}>
      <Row gutter={12} justify="space-around">
        {editar ? (
          <Col>
            <Form.Item label="Conta" name="contaBanco">
              <Input type="text" style={{ width: "172px" }} disabled />
            </Form.Item>
          </Col>
        ) : (
          <Form.Item
            label="Empresa"
            name="idEmpresa"
            className="denominacaoFeriado"
            rules={[
              {
                required: true,
                message: "Selecione a empresa",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="labelSearch"
              placeholder="Selecione uma empresa"
              loading={empresaState.loading}
              style={{ width: 319 }}
              options={empresaState.list.map((a: EmpresaModel) => ({
                value: a.id,
                key: a.apelido,
                label: (
                  <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                    <div style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</div>
                    {a.apelido}
                  </Flex>
                ),
                labelSearch: a.apelido,
              }))}
            />
          </Form.Item>
        )}
        <Col>
          <Form.Item label="Fechamento movimentação" name="dataFechamentoMovimentacao">
            <DatePicker format="DD/MM/YYYY" style={{ width: "180px" }} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Fechamento classificação"
            name="dataFechamentoClassificacao"
            dependencies={["dataFechamentoMovimentacao"]}
            rules={[
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value && getFieldValue("dataFechamentoMovimentacao")) {
                    return Promise.reject(new Error("Digite a data de classificação"));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <DatePicker format="DD/MM/YYYY" disabled={verificaInputMovimentacao} style={{ width: "180px" }} />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <div className="modalFooter">
        <Space size="middle">
          <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
            {editar ? "ATUALIZAR" : "SALVAR"}
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default FecharEmpresaFechamentoFinanceiro;
